import { theme as ozone } from 'ozone';

export const theme = {
  mode: 'light',
  header: {
    layer: 9,
    height: 74,
  },
  filters: {
    height: 48,
    layer: 8,
  },
  table: {
    header_height: {
      small: '1.5rem',
      medium: '2rem',
      large: '2.5rem',
    },
    row_height: {
      small: '2rem',
      medium: '2.5rem',
      large: '3rem',
    },
  },
  menu: {
    height: 40,
  },
  body: {
    layer: 1,
  },
  layout: {
    layout_01: '1rem',
  },
  heights: {
    small: '1.5rem',
    medium: '2rem',
    large: '2.5rem',
  },
  rem_base: 16,
  pixels: (rem: number | string) =>
    typeof rem === 'number'
      ? theme.rem_base * rem
      : theme.rem_base * parseFloat(rem.replace('rem', '').trim()),
  z_index: (layer: number) => `var(--zindex-layer-${`0${layer}`})`,
  ...ozone,
};

export const grayTheme = { ...theme, mode: 'gray' };
